export default __webpack_public_path__ + "static/orsusecase2-6e38784e496a9bb31569c02c7edb25ee.jpg";